<template>
  <div class="ImageTags">
    <Tag v-for="tag in image.tags" :key="tag">
      {{ tag }}
      <Btn
        class="ib xs inv"
        :disabled="isRemoving"
        :isLoading="isRemoving"
        @click="removeTag(tag)">
        <Icon name="cross" />
      </Btn>
    </Tag>
    <Field
      v-show="doShowInput"
      ref="field"
      class="ib xs"
      :disabled="isAdding"
      :value.sync="value"
      @keyup.enter.prevent.native="addTag" />
    <Btn
      class="ib add sm light"
      :isLoading="isAdding"
      @click="toggleInput">
      <Icon name="plus" />
    </Btn>
  </div>
</template>

<script>
import { actions } from '@utils'
import { removeItem } from '@utils/collections'
import { trim } from 'rambda'

export default {
  props: {
    image: { type: Object, required: true },
  },
  data() {
    return {
      doShowInput: false,
      isAdding: false,
      isRemoving: false,
      value: null,
    }
  },
  methods: {
    toggleInput() {
      this.doShowInput = !this.doShowInput

      if (this.doShowInput) {
        setTimeout(() => {
          this.$refs.field.$refs.input.focus({ focusVisible: true })
        }, 20)
      }
    },
    async addTag() {
      if (this.isAdding) return

      return this.$wrap(
        async () => {
          await this.patchTags([
            ...this.image.tags,
            ...this.value.split(',').map(trim),
          ])

          this.value = null
          this.toggleInput()
        },
        'isAdding',
      )
    },
    removeTag(tag) {
      if (this.isRemoving) return

      return this.$wrap(
        () => this.patchTags(removeItem(
          tag,
          this.image.tags,
        )),
        'isRemoving',
      )
    },
    patchTags(tags) {
      return this.PATCH_FILE({
        id: this.image.id,
        tags,
      })
    },
    ...actions('PATCH_FILE'),
  },
}
</script>

<style lang="scss">
.ImageTags {
  .Tag {
    margin-right: 0.5rem;
    padding-right: 0.25rem;

    .Btn {
      color: $white;
      padding: 0 0.25rem;

      &:hover {
        color: $info;
      }
    }
  }

  .Btn.add {
    padding: 0;
    width: 2rem;
  }
}
</style>
